export default __webpack_public_path__ + "static/media/10.d9799173.svg";